import type { AnnotationManager } from '@atlaskit/editor-common/annotation';
import type {
	AnnotationPluginOptions,
	InlineCommentAnnotationProvider,
} from '@atlaskit/editor-plugin-annotation';
import { fg } from '@atlaskit/platform-feature-flags';

interface Props {
	options: {
		annotationManager: AnnotationManager | undefined;
		createCommentExperience: AnnotationPluginOptions['createCommentExperience'];
		selectCommentExperience:
			| {
					selectAnnotation: {
						complete: (_: {
							pageClass: 'editor';
							annotationId: string;
							entryPoint: 'annotation-change';
						}) => void;
					};
			  }
			| undefined;
		viewInlineCommentTraceUFOPress?: () => void;
	};
	providers: { inlineCommentAnnotationProvider?: InlineCommentAnnotationProvider };
}

export function annotationPluginOptions({
	options,
	providers,
}: Props): AnnotationPluginOptions | undefined {
	if (!providers.inlineCommentAnnotationProvider) {
		return undefined;
	}

	return {
		inlineComment: providers.inlineCommentAnnotationProvider,
		createCommentExperience: options.createCommentExperience,
		selectCommentExperience: {
			selectAnnotation: {
				complete: (annotationId: string) => {
					options.selectCommentExperience?.selectAnnotation.complete({
						pageClass: 'editor',
						annotationId,
						entryPoint: 'annotation-change',
					});
				},
			},
		},
		viewInlineCommentTraceUFOPress: fg('cc_comments_track_view_inline_comment_action')
			? options.viewInlineCommentTraceUFOPress
			: undefined,
		annotationManager: options.annotationManager,
	};
}
